import React, { useImperativeHandle, useState, forwardRef } from 'react'
import Button from '@material-ui/core/Button'

//images
import headerPlayIcon from '../../../assets/images/test/play-icon.png'
import playIcon from '../../../assets/images/test/play-video-icon.png'

function VideosCommentList(props, ref) {
    const initialState = {
        videos: []
    }
    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        ...initialState
    })

    useImperativeHandle(ref, () => ({
        open: videos => handleOpen(videos),
        close: () => handleClose()
    }))

    const handleOpen = videos => {
        setMajor(major => ({
            ...major,
            blur: true,
            videos
        }))

        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))
        }, 50)
    }

    const handleClose = async () => {
        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`law-comment-overlay ${major.blur ? 'visible' : ''}`}>
            <div className={`box videos-list ${major.popup ? 'show' : ''}`}>
                <div className="header">
                    <img src={headerPlayIcon} />
                    Научи повече
                </div>
                <ul className="list">
                    {major.videos.map(video =>
                        <li key={video.id} onClick={() => props.handleVideoComment(video.topic.video_id, video.start_pos, video.end_pos)}>
                            <picture style={{ backgroundImage: `url(${video.poster})` }}>
                                <img src={playIcon} />
                            </picture>
                            <div className="right">
                                <h4>
                                    {video.topic.name}
                                </h4>
                                <time>
                                    {video.duration_formatted}
                                </time>
                            </div>
                        </li>
                    )}
                </ul>

                <div className="buttons">
                    <Button className="cancel-request" onClick={handleClose}>
                        Затвори
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(VideosCommentList)